import Inplace from '@/components/landing/common/Inplace';
import { CoverageVisual } from '@/components/landing/product/main/datasets/coverage-visual'
import { FinancialsVisual } from '@/components/landing/product/main/datasets/financials-visual'
import { ContextVisual } from '@/components/landing/product/main/datasets/context-visual'
import { SignalVisual } from '@/components/landing/product/main/datasets/signal-visual'

const FEATURES = [
  {
    badge: 'COVERAGE',
    heading: 'One surface,\nevery market',
    body: 'Equities, ETFs, forex, futures, indices, and crypto brought together in a single, consistent market data API. Stop stitching datasets and start seeing the full market clearly.',
    cta: 'Get Started Free',
    ctaUrl: '/login',
    visual: 'coverage',
  },
  {
    badge: 'FUNDAMENTALS',
    heading: 'Every metric\nthat matters',
    body: 'Financial statements, earnings, SEC filings, and macro data structured directly from source material. Trace every number back to reality with no black boxes in between.',
    cta: 'Explore Financials',
    ctaUrl: '/products',
    visual: 'financials',
  },
  {
    badge: 'CONTEXT',
    heading: 'See what\nothers miss',
    body: 'Go beyond price and fundamentals with alternative data, including ESG, credit, supply chain relationships, sentiment, and web traffic. Understand how companies actually operate and move.',
    cta: 'Discover signals',
    ctaUrl: '/products',
    visual: 'context',
  },
  {
    badge: 'SIGNAL',
    heading: 'Turn data\ninto direction',
    body: 'Clean, connected datasets designed for fast analysis and model building. Move from raw information to actionable insight without friction.',
    cta: 'Start building',
    ctaUrl: '/login',
    visual: 'signal',
  },
];

const VISUALS = {
  coverage:   CoverageVisual,
  financials: FinancialsVisual,
  context:    ContextVisual,
  signal:     SignalVisual,
};

const StickyScrollSection = () => (
  <Inplace
    visuals={VISUALS}
    slides={FEATURES}
  />
);

export default StickyScrollSection;
